/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_SubtitleInputs */



/**
* | output |
* | --- |
* | "Run scheduled jobs now instead of waiting for their schedule." |
*
* @param {Admin_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_subtitle = /** @type {((inputs?: Admin_SubtitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_SubtitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lancer maintenant les tâches planifiées, sans attendre leur horaire.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ejecutar ahora las tareas programadas, sin esperar a su horario.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodar agora as tarefas agendadas, sem esperar o horário delas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esegui subito le attività pianificate, senza aspettare il loro orario.")
	return /** @type {LocalizedString} */ ("Run scheduled jobs now instead of waiting for their schedule.")
});